<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import AttAnalysis from "./att-analysis";
import LeaveDetails from "./leave-details";
import simplebar from "simplebar-vue";
import EmpAttList from "./att-list-emp";
import Drawer from "vue-simple-drawer";
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  page: {
    title: "Attendance",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Drawer,
    PageHeader,
    AttAnalysis,
    LeaveDetails,
    EmpAttList,
    simplebar,
  },
  data() {
    return {
      title: "Attendance Analysis",
      autoClose: "",
      loginData: {},
      sendEmpId: 0,
      currMonth: '',
      testDateRange: {
        startDate: null,
        endDate: null
      },
      preDefinedRange: {},
      empLoader: false,
      exportModal: false,
      curr: {
        empId: null,
      },
      employees: [],
      leaveBalance: [],
      leaveBalLoader : false,
      leaveData: [],
      currMonthAttDashboardData: {
        presentDays: 0,
        absentDays: 0,
        lateDays: 0,
      },

      filterValue: "",
      loader: false,
      empAttDashboardLoader: false,
      openRightDrawer: false,
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Blog",
          active: true,
        },
      ],
    };
  },
  methods:{
    async getAllEmployees() {
      this.empLoader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            this.employees = response.data.data;
            if(this.sendEmpId == 0) {
              this.curr = this.employees[0];
            } else {
              for(var i = 0;i < this.employees.length;i++) {
                if(this.sendEmpId == this.employees[i].empId) {
                  this.curr = this.employees[i];
                }
              }
            }
            this.empLoader = false;
            this.getEmployeeDashboardAttendanceData();
            //this.getLeaveBalance();
          }
        }
      } catch (error) {
        this.empLoader = false;
      }
      this.empLoader = false;
    },
    async getEmployeeDashboardAttendanceData() {
      this.empAttDashboardLoader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_employee_dashboard_attendance_data",
          { params: { companyId: this.loginData.companyId, empId: this.curr.empId } }
        );
        if(response.data.success == "true") {
          this.currMonthAttDashboardData.presentDays = response.data.data.presentDays;
          this.currMonthAttDashboardData.absentDays = response.data.data.absentDays;
          this.currMonthAttDashboardData.lateDays = response.data.data.lateDays; 
        }
      } catch (error) {
        this.empAttDashboardLoader = false;
      }
      this.empAttDashboardLoader = false;
    },
    async getLeaveBalance() {
      this.leaveBalLoader = true;
      this.leaveBalance = [];
      try {
        const response = await axios.get(`https://workrhythm.net:8090/employee/get_leave_balance`,{
          params: { companyId: this.loginData.companyId, empId: this.curr.empId},
        }
        );

        if(response.data.success == "true") {
          this.leaveBalance = response.data.data;
        }
      } catch (error) {
        this.leaveBalLoader = false;
      }
      this.leaveBalLoader = false;
    },
    onEmployeeChange(data) {
      this.curr = data;
      this.getEmployeeDashboardAttendanceData();
      //this.getLeaveBalance();

      setTimeout(() => {
        this.openRightDrawer = false;
      }, 300);
    },
    rightDrawer() {
      this.openRightDrawer = !this.openRightDrawer;
    },
    downloadLeaveBalance() {
      var fields = ["leaveName", "used", "available", "teamName", "total", "carried"];
      let fileName = this.curr.name+"_leavebalance.csv";
      this.convertToCSV(this.leaveBalance, fields, fileName);
    },
    toSnakeCase(inputString) {
      return inputString.split('').map((character) => {
          if (character == character.toUpperCase()) {
              return ' ' + character;
          } else {
              return character;
          }
      })
      .join('');
    },
    async convertToCSV(data, fields, fileName) {
      const json = data;
      //var fields = Object.keys(json[0])
      //var fields = ["name", "email", "designation", "teamName", "activeHours", "idleHours", "productivity"];
      var replacer = function(key, value) { return value === null ? '' : value } 
      var csv = json.map(function(row){
        return fields.map(function(fieldName){
          let data = row[fieldName];
          return JSON.stringify(data, replacer)
        }).join(',')
      })

      // Name, Email, Designation, Team Name, Active Hours, Idle Hours, Productivity
      for(var i = 0;i < fields.length;i++) {
        fields[i] = this.toSnakeCase(fields[i]);
        fields[i] = fields[i].charAt(0).toUpperCase() + fields[i].slice(1);
      }
      csv.unshift(fields.join(',')) // add header column
      csv = csv.join('\r\n');

      //console.log(csv);
      var exportedFilenmae = fileName;
      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
          var link = document.createElement("a");
          if (link.download !== undefined) { // feature detection
              // Browsers that support HTML5 download attribute
              var url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", exportedFilenmae);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
          }
      }
    },
  },
  created() {
    let today = new Date()
  today.setHours(0, 0, 0, 0)

    let yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)
    yesterday.setHours(0, 0, 0, 0);
    this.preDefinedRange = {
        'Today': [today, today],
        'Yesterday': [yesterday, yesterday],
        'This week': [yesterday, yesterday],
        'This month': [yesterday, yesterday],
        'This year': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
        'Last Week': [yesterday, yesterday],
        'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
        'Last year': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
    }  

    if(!this.$route.params.data) {
      this.sendEmpId = 0
    } else {
      this.sendEmpId = this.$route.params.data;
    }
    this.loginData = JSON.parse(localStorage.getItem('user'));
    var date = new Date();
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    this.currMonth = months[date.getMonth()] + ', ' + date.getFullYear().toString().slice(-2);
    this.getAllEmployees();
  },
  mounted() {

  },
  computed: {
    searchevents: function () {
      var result = this.employees;
      if (!this.filterValue) return result;

      const filterValue = this.filterValue.toLowerCase();

      const filter = (event) =>
        event.name.toLowerCase().includes(filterValue) ||
        event.message.toLowerCase().includes(filterValue);

      return result.filter(filter);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menuitems.attendance.attendanceAnalysis')" />
    
    <!--<div class="row mb-2">
      <div class="col-md-8"></div>
      <div class="col-md-4 text-end">
        sjdud
        <date-picker
          v-model="autoClose"
          :first-day-of-week="1"
          placeholder="select date"
          input-class="focus:outline-none"
          lang="en"
        ></date-picker>
      </div>
    </div>-->
    <div>
      <div class="row">
        <div class="col-xl-8">
          <div class="row">
            <div class="col-lg-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="is-loading">
                    <div class="preloader-component" v-show="empAttDashboardLoader">
                      <div class="status">
                        <div class="spinner-chase">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">{{ $t('menuitems.attendance.present') }}</p>
                      <span class="mb-0 font-size-20">{{currMonthAttDashboardData.presentDays}} </span>
                      <span class="text-muted font-size-12"
                        >{{ $t('menuitems.attendance.days') }} ({{currMonth}})</span
                      >
                    </div>

                    <div class="avatar-sm ms-auto">
                      <div
                        class="
                          avatar-title
                          bg-light
                          rounded-circle
                          text-primary
                          font-size-20
                        "
                      >
                        <i class="bx bx-user-check"></i>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="is-loading">
                    <div class="preloader-component" v-show="empAttDashboardLoader">
                      <div class="status">
                        <div class="spinner-chase">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">{{ $t('menuitems.attendance.absent') }}</p>
                      <span class="mb-0 font-size-20">{{currMonthAttDashboardData.absentDays}} </span>
                      <span class="text-muted font-size-12"
                        >{{ $t('menuitems.attendance.days') }} ({{currMonth}})</span
                      >
                    </div>

                    <div class="avatar-sm ms-auto">
                      <div
                        class="
                          avatar-title
                          bg-light
                          rounded-circle
                          text-primary
                          font-size-20
                        "
                      >
                        <i class="bx bx-user-x"></i>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="is-loading">
                    <div class="preloader-component" v-show="empAttDashboardLoader">
                      <div class="status">
                        <div class="spinner-chase">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">{{ $t('menuitems.attendance.late') }}</p>
                      <span class="mb-0 font-size-20">{{currMonthAttDashboardData.lateDays}} </span>
                      <span class="text-muted font-size-12"
                        >{{ $t('menuitems.attendance.days') }} ({{currMonth}})</span
                      >
                    </div>

                    <div class="avatar-sm ms-auto">
                      <div
                        class="
                          avatar-title
                          bg-light
                          rounded-circle
                          text-primary
                          font-size-20
                        "
                      >
                        <i class="bx bx-run"></i>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end row -->

          <div class="card">
            <AttAnalysis :key="curr.empId" :dataProp="curr"/>
          </div>
          
          <EmpAttList :key="curr.empId" :dataProp="curr"/>
        
        </div>
        <!-- end col -->

        <div class="col-xl-4">
          <div class="card">
            <div class="card-body">
              <div class="d-flex">
                <div class="me-3">
                  <div class="avatar-sm align-self-center me-3">
                          <span
                            v-if="curr.name != null"
                            class="
                              avatar-title
                              rounded-circle
                              bg-soft bg-primary
                              text-primary
                              fs-4
                            "
                            >{{ curr.name.charAt(0) }}</span
                          >
                        </div>
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted">
                        <h5 class="mb-1">{{curr.name}}</h5>
                        <p class="mb-0">{{curr.designation}}</p>
                      </div>
                    </div>
                    <button
                        class="btn btn-outline-primary btn-sm"
                        @click="rightDrawer"
                      >
                        Change
                        <i class="mdi mdi-arrow-right ms-1"></i>
                      </button>
                   <!-- <b-dropdown
                      toggle-class="btn-sm"
                      variant="light"
                      right
                      class="ms-2"
                      menu-class="dropdown-menu-end"
                    >
                      <template #button-content variant="outline-primary">
                        <i class="bx bxs-cog align-middle me-1"></i> Change
                      </template>
                      <a class="dropdown-item" href="#">Action</a>
                      <a class="dropdown-item" href="#">Another action</a>
                      <a class="dropdown-item" href="#">Something else</a>
                    </b-dropdown>-->
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-12">
                      <div>
                        <p class="text-muted text-truncate mb-2">
                          {{ $t('menuitems.attendance.shiftPattern') }}
                        </p>
                        <h6 class="mb-0">{{curr.shiftStartTime}} - {{curr.shiftEndTime}}, {{curr.workingDaysCount}} {{ $t('menuitems.attendance.daysWeek') }}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body" style="height: calc(100vh - 515px);">
              <div class="is-loading">
                    <div class="preloader-component" v-show="leaveBalLoader" >
                      <div class="status">
                        <div class="spinner-chase">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                <div class="row">
                  <div class="col-md-6">
                    <h5 class="card-title mb-3 me-2">{{ $t('menuitems.attendance.leaveBalance') }}</h5>
                  </div>
                  <!--<div class="col-md-6 text-end">
                    <button class="btn btn-link" @click="downloadLeaveBalance"><i class="bx bx-download"></i> {{ $t('menuitems.attendance.download') }}</button>
                  </div>-->
                </div>
                <!--<simplebar style="max-height: calc(100vh - 575px);overflow-x: hidden;" >-->
                    <div v-if="leaveBalance.length > 0" class="table-responsive table-hover mb-0">
                      <table class="table table-fixed">
                        <thead class="">
                          <tr>
                            <th scope="col">{{ $t('menuitems.attendance.leave') }}</th>
                            <th scope="col">{{ $t('menuitems.attendance.used') }}</th>
                            <th scope="col">{{ $t('menuitems.attendance.available') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(data, index) in leaveBalance" :key="index">
                            <td>
                                {{ data.leaveName }}
                            <td>
                              <span class="fw-bold">{{ data.used }}</span>
                            <td>
                              <span class="fw-bold">{{ data.available }} <span v-if="data.carried > 0" >( {{ data.carried }} )<sup><i class="bx bx-question-mark" style="cursor: pointer;" v-b-tooltip.hover :title="$t('menuitems.attendance.carried')"></i></sup></span></span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-if="leaveBalance.length <= 0" style="margin-top: 18%;margin-left: 28%;">
                      <img src="@/assets/images/no-data.png" alt="No Data"  height="120" width="120"><br />
                      <span class="mt-2 text-secondary fw-bold fs-4">{{ $t('menuitems.attendance.noDataFound') }}</span>
                    </div>
                  <!--</simplebar>-->
              </div>
            </div>
          </div>

           <LeaveDetails :key="curr.empId" :dataProp="curr"/>
        </div>
       
        <!-- end col -->
      </div>
      <!-- end row -->
      <!--
      <div class="row">
        <div class="col-xl-4 col-lg-6">
          <Posts />
        </div>

        <div class="col-xl-4 col-lg-6">
          <Comments />
        </div>

        <div class="col-xl-4">
          <TopVisitor />
        </div>
      </div>
      -->

      <!--<div class="row">
        <div class="col-xl-8">
          <EmpAttList :key="curr.empId" :dataProp="curr"/>
        </div>
        <div class="col-xl-4">
          <LeaveDetails />
        </div>
      </div>-->
      <!-- end row -->
    </div>

    <b-modal v-model="exportModal" size="md" centered :title="'Export Data'" hide-footer>
        <date-range-picker
            ref="picker"
            :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
            :showDropdowns="true"
            :ranges="preDefinedRange"
            v-model="testDateRange"
        >
        </date-range-picker>
    </b-modal>

     <Drawer
      @close="rightDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openRightDrawer">
        <div class="offcanvas-header">
          <h4
            class="offcanvas-title text-truncate"
            id="offcanvasExampleLabel"
            style="width: 320px"
          >
            {{ $t('menuitems.attendance.selectEmployee') }}
          </h4>
        </div>

        <div class="offcanvas-body mt-0">
          <div class="search-box py-2">
            <div class="position-relative">
              <input
                type="text"
                class="form-control"
                :placeholder="$t('menuitems.attendance.search') + '...'"
                v-model="filterValue"
              />
              <i class="bx bx-search-alt search-icon"></i>
            </div>
          </div>
          <div v-if="searchevents.length > 0">
            <simplebar style="max-height: 630px">
              <ul class="list-unstyled chat-list">
                <li
                  class
                  v-for="data of searchevents"
                  :key="data.empId"
                  @click="onEmployeeChange(data)"
                  :class="{ active: curr.empId == data.empId }"
                >
                  <a href="javascript: void(0);">
                    <div class="row">
                      <div class="col-md-1">
                        <i
                          :class="`mdi mdi-circle text-${data.color} font-size-10`"
                        ></i>
                      </div>
                      <div class="avatar-xs col-md-3" style="width: 55px">
                        <span
                          class="
                            avatar-title
                            rounded-circle
                            bg-soft bg-primary
                            text-primary
                          "
                          >{{ data.name.charAt(0) }}</span
                        >
                      </div>
                      <div class="col-md-8">
                        <span class="text-truncate font-size-14 mb-1">{{
                          data.name
                        }}</span>
                        <p class="text-truncate mb-0">{{ data.email }}</p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </simplebar>
          </div>
          <div v-if="searchevents.length <= 0">
              <img src="@/assets/images/no-data.png" alt="No Data" style="margin-top: 77%;margin-left: 22%;" height="180" width="180"><br />
              <span style="margin-left: 23%;" class="mt-2 text-secondary fw-bold fs-3">No Data Found</span>
          </div>
        </div>
      </div>
    </Drawer>
  </Layout>
</template>

<style scoped>
table {
        table-layout:fixed;
    }
 .tooltip{
    opacity: 1 !important;
  }
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
table {
        table-layout:fixed;
    }
tbody {
    display:block;
    height: calc(100vh - 650px);
    overflow:auto;
}
thead, tbody tr {
    display:table;
    width:100%;
    table-layout:fixed;
}
</style>